import styled, { css, DefaultTheme } from 'styled-components';
import { mediasQuery } from '@utils/responsive';
import { SizeType } from '../BaseInput/BaseInputTypes';
import { DropDownProps } from './DropDownTypes';

const inputSizeMapping = (size: SizeType = 'small', theme: DefaultTheme) => {
  const map = {
    small: theme.spacing.km8,
    medium: theme.spacing.km12,
    large: theme.spacing.km12,
  };

  return map[size];
};

const Panel = styled.div<Partial<DropDownProps>>`
  ${({ open, position }) => css`
    visibility: ${open ? 'visible' : 'hidden'};
    z-index: 3;
    transform-origin: ${position === 'bottom' ? 'top' : 'bottom'};
    transition-delay: 0.1s;
    transition: all 0.3s cubic-bezier(0.65, 0, 0.35, 1);
    transform: ${open ? 'scaleY(1)' : 'scaleY(0)'};
  `}
`;

export const Wrapper = styled.div<Partial<DropDownProps>>`
  position: relative;
`;

const ContainerModifiers = {
  top: () => css`
    top: 0;
  `,
  bottom: (size: SizeType = 'small', theme: DefaultTheme) => css`
    bottom: ${inputSizeMapping(size, theme)};
  `,
};

export const Container = styled(Panel)`
  ${({
    theme,
    width,
    position,
    inputSize,
    borderOff,
    dropdownSpacing,
    customMaxHeight,
  }) => {
    return css`
      position: absolute;
      min-width: ${width};
      width: 100%;
      right: 0;
      max-height: ${customMaxHeight ?? '280'}px;
      overflow-y: auto;
      margin-top: ${dropdownSpacing
        ? theme.spacing[dropdownSpacing]
        : theme.spacing.km2};
      border: ${theme.border.width.thinner} solid
        ${theme.color.border.neutral.medium};
      border-radius: ${theme.border.radius.large};
      box-sizing: border-box;
      box-shadow: ${theme.elevation.ton3};
      background-color: ${theme.color.background.neutral.default};
      ${position === 'bottom'
        ? ContainerModifiers.top()
        : ContainerModifiers.bottom(inputSize, theme)};

      ::-webkit-scrollbar {
        width: 12px;
      }

      ::-webkit-scrollbar-thumb {
        border: 4px solid transparent;
        background-clip: padding-box;
        border-radius: ${theme.border.radius.pill};
        background-color: ${theme.color.icon.neutral.weak};
      }

      ${mediasQuery.maxMdMax} {
        ${borderOff &&
        css`
          border: none;
          box-shadow: none;
        `};
      }
    `;
  }}
`;
